
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    const addedRoutes = router.getRoutes().filter(r => !r._initial)
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      for (const route of router.getRoutes()) {
        route._initial = true
      }
      for (const route of addedRoutes) {
        router.addRoute(route)
      }
      router.isReady().then(() => {
        // Resolve the current path against the new routes to get updated meta
        const newRoute = router.resolve(router.currentRoute.value.fullPath)
        // Clear old meta values and assign new ones
        for (const key of Object.keys(router.currentRoute.value.meta)) {
          delete router.currentRoute.value.meta[key]
        }
        Object.assign(router.currentRoute.value.meta, newRoute.meta)
      })
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
    for (const route of _router.getRoutes()) {
      route._initial = true
    }
  }
}
import { default as knockfKsfRrN2c9hNOcmpPrqxSZARMN1hBqYntCqLWG2CXbIMeta } from "/opt/buildhome/repo/app/pages/knock.vue?macro=true";
import { default as _91_46_46_46slug_93_0ZERmeKg__97aWWO2qTLlEheqCXjmWFXVaDkyvUojIMeta } from "/opt/buildhome/repo/app/pages/[...slug].vue?macro=true";
import { default as indexBUquJ6FW9selPoMmXmiQ06xberjjtjDDexnQK6NGwH0Meta } from "/opt/buildhome/repo/app/pages/index.vue?macro=true";
export default [
  {
    name: "profile-id-posts",
    path: "/profile/:id()/posts",
    meta: {"middleware":"profile-member-no"},
    component: () => import("/opt/buildhome/repo/app/pages/profile/[id]/posts.vue")
  },
  {
    name: "post-id",
    path: "/post/:id()",
    meta: {"middleware":"post-no"},
    component: () => import("/opt/buildhome/repo/app/pages/post/[id].vue")
  },
  {
    name: "profile-id",
    path: "/profile/:id()",
    meta: {"middleware":"profile-member-no"},
    component: () => import("/opt/buildhome/repo/app/pages/profile/[id]/index.vue")
  },
  {
    name: "tags-slug",
    path: "/tags/:slug()",
    component: () => import("/opt/buildhome/repo/app/pages/tags/[slug].vue")
  },
  {
    name: "account",
    path: "/account",
    component: () => import("/opt/buildhome/repo/app/pages/account.vue")
  },
  {
    name: "create",
    path: "/create",
    component: () => import("/opt/buildhome/repo/app/pages/create.vue")
  },
  {
    name: "exam",
    path: "/exam",
    component: () => import("/opt/buildhome/repo/app/pages/exam.vue")
  },
  {
    name: "knock",
    path: "/knock",
    meta: knockfKsfRrN2c9hNOcmpPrqxSZARMN1hBqYntCqLWG2CXbIMeta || {},
    component: () => import("/opt/buildhome/repo/app/pages/knock.vue")
  },
  {
    name: "level",
    path: "/level",
    component: () => import("/opt/buildhome/repo/app/pages/level.vue")
  },
  {
    name: "login",
    path: "/login",
    component: () => import("/opt/buildhome/repo/app/pages/login.vue")
  },
  {
    name: "search",
    path: "/search",
    component: () => import("/opt/buildhome/repo/app/pages/search.vue")
  },
  {
    name: "slug",
    path: "/:slug(.*)*",
    meta: _91_46_46_46slug_93_0ZERmeKg__97aWWO2qTLlEheqCXjmWFXVaDkyvUojIMeta || {},
    component: () => import("/opt/buildhome/repo/app/pages/[...slug].vue")
  },
  {
    name: "index",
    path: "/",
    meta: indexBUquJ6FW9selPoMmXmiQ06xberjjtjDDexnQK6NGwH0Meta || {},
    component: () => import("/opt/buildhome/repo/app/pages/index.vue")
  }
]